export function isValidQueryInput(query: string) {
  if (typeof query !== 'string') return false;

  // Trim leading/trailing spaces to avoid false negatives
  const q = query.trim();

  // Strict structural check using a regular expression.
  // ^MODE <anything> FROM <anything> SHOW <anything>$
  const pattern = /^MODE\b[\s\S]*\bFROM\b[\s\S]*\bSHOW\b[\s\S]*$/;

  return pattern.test(q);
}
